import { render, staticRenderFns } from "./CardFancy.vue?vue&type=template&id=181b7136&"
import script from "./CardFancy.vue?vue&type=script&lang=js&"
export * from "./CardFancy.vue?vue&type=script&lang=js&"
import style0 from "./CardFancy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports